/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelGetVoucherBySellIdPost } from '../fn/get-voucher-info-by-sell-id-endpoint/api-hotel-get-voucher-by-sell-id-post';
import { ApiHotelGetVoucherBySellIdPost$Params } from '../fn/get-voucher-info-by-sell-id-endpoint/api-hotel-get-voucher-by-sell-id-post';
import { GetVoucherResponseInfoResultApiResult } from '../models/get-voucher-response-info-result-api-result';

@Injectable({ providedIn: 'root' })
export class GetVoucherInfoBySellIdEndpointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHotelGetVoucherBySellIdPost()` */
  static readonly ApiHotelGetVoucherBySellIdPostPath = '/api/hotel/GetVoucherBySellId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelGetVoucherBySellIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetVoucherBySellIdPost$Response(params: ApiHotelGetVoucherBySellIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoucherResponseInfoResultApiResult>> {
    return apiHotelGetVoucherBySellIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelGetVoucherBySellIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelGetVoucherBySellIdPost(params: ApiHotelGetVoucherBySellIdPost$Params, context?: HttpContext): Observable<GetVoucherResponseInfoResultApiResult> {
    return this.apiHotelGetVoucherBySellIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVoucherResponseInfoResultApiResult>): GetVoucherResponseInfoResultApiResult => r.body)
    );
  }

}
